import React, { FC } from 'react';
import { AllieText } from '../../../../components';
import { AllieClockIcon } from '../../../../styling/icons';
import { FlexContainer, IconContainer } from '../StationListSummaryCard.styles';

export const ShiftField: FC<{ shiftName: string }> = ({ shiftName }) => {
  return (
    <FlexContainer alignItems="center" gap={5} style={{ width: 'fit-content' }}>
      <IconContainer>
        <AllieClockIcon allieColor="neutral-40" color="neutral-40" display={'flex'} />
      </IconContainer>

      <AllieText type="body2" weight={600}>
        {shiftName}
      </AllieText>
    </FlexContainer>
  );
};
